import MuiTabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';
import { globalClasses } from 'core/common/constants/global-classes';

export const TabsStyled = styled(MuiTabs)`
  & ${globalClasses.tabIndicator} {
    display: none;
  }
`;
